module.exports = __webpack_public_path__ + "img/service-white-icon1.b719dc1e.png";